import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Landing from "@/pages/Landing";
import Journal from "@/pages/Journal";
import Words from "@/pages/Words";
import Mirror from "@/pages/Mirror";
import RedLetters from "@/pages/RedLetters";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import DailyFeed from "@/pages/DailyFeed";
import CommonThread from "@/pages/CommonThread";
import Lexicon from "@/pages/Lexicon";
import Community from "@/pages/Community";
import PowerOfWords from "@/pages/PowerOfWords";
import Roots from "@/pages/Roots";
import SpokenWords from "@/pages/SpokenWords";
import WordArchive from "@/pages/WordArchive";
import OurHeart from "@/pages/OurHeart";
import TheWell from "@/pages/TheWell";
import Pricing from "@/pages/Pricing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import TheMirror from "@/pages/TheMirror";
import ScrollTop from "@/components/ScrollTop";
import { AuthProvider } from "@/context/AuthContext";
import { LockProvider } from "@/context/LockContext";
import LockScreen from "@/components/LockScreen";
import PinSettingsDialog from "@/components/PinSettingsDialog";
import ProtectedRoute from "@/components/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <LockProvider>
          <ScrollTop />
          <Navbar />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/our-heart" element={<OurHeart />} />
            <Route path="/the-mirror" element={<TheMirror />} />
            <Route path="/well" element={<TheWell />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/feed" element={<DailyFeed />} />
            <Route path="/common-thread" element={<CommonThread />} />
            <Route path="/community" element={<Community />} />
            <Route path="/power-of-words" element={<PowerOfWords />} />
            <Route path="/roots" element={<Roots />} />
            <Route path="/word-archive" element={<WordArchive />} />
            <Route
              path="/spoken"
              element={
                <ProtectedRoute>
                  <SpokenWords />
                </ProtectedRoute>
              }
            />
            <Route
              path="/lexicon"
              element={
                <ProtectedRoute>
                  <Lexicon />
                </ProtectedRoute>
              }
            />
            <Route
              path="/journal"
              element={
                <ProtectedRoute>
                  <Journal />
                </ProtectedRoute>
              }
            />
            <Route path="/words" element={<Words />} />
            <Route path="/mirror" element={<Mirror />} />
            <Route path="/red-letters" element={<RedLetters />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
          </Routes>
          <footer className="border-t border-white/5 mt-24 py-10 px-6 text-center text-sm text-[#A8A29E]">
            <p className="italic-serif text-lg text-[#D4AF37]/80">Mirrors of Your Soul</p>
            <p className="mt-2">The kingdom of heaven is within you. Seek, and you will find.</p>
          </footer>
          <Toaster position="top-center" />
          <PinSettingsDialog />
          <LockScreen />
          </LockProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
